import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Section2 = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
        ease: "easeInOut"
      },
    },
    exit: {
      transition: { duration: 0, delay: 0 },
    },
  };
  const itemVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 , ease: "easeInOut"} },
    exit: { opacity: 0, y: 20, transition: { duration: 0, delay: 0 } },
  };

  const photoVariants = {
    initial: { scale: 1.2, transition: { duration: 3, ease: "easeInOut" } },
    whileInView: { scale: 1, transition: { duration: 3, ease: "easeInOut" } },
    exit: { scale: 1.2, transition: { duration: 0, delay: 0 } },
  };
  
  return (
    <motion.div
      className="grid grid-cols-10 relative group py-20"
      initial="hidden"
      whileInView="visible"
      exit="exit"
      variants={containerVariants}
    >
      <div className="col-start-2 col-span-8 grid grid-cols-5 z-50">
        <div className="col-span-5 md:col-span-2 text-white font-thin flex flex-col space-y-10 mb-14 md:mb-0">
          <motion.h2 variants={itemVariants} className="text-65 leading-none">
            {t("home.sustainability.title1")}
            <br />
            {t("home.sustainability.title2")}
          </motion.h2>

          <motion.p variants={itemVariants} className="text-20">
            {t("home.sustainability.quote")}
          </motion.p>
        </div>

        <div className="col-span-5 md:col-span-3 h-ful flex space-x-10">
          <motion.div
            whileInView={{ height: "100%" }}
            initial={{ height: "0%" }}
            transition={{ duration: 2.5 }}
            exit={{ height: "0%", transition: { duration: 0, delay: 0 } }}
            className="w-0.5 bg-white"
          ></motion.div>
          <motion.div
            className="grid grid-cols-1 md:grid-cols-2 grid-rows-3 space-y-5 md:space-y-0 h-full"
            variants={containerVariants}
          >
            {[1, 2, 3, 4, 5, 6].map((id) => (
              <motion.div
                key={id}
                className="flex text-white space-x-2 font-thin"
                variants={itemVariants}
              >
                <motion.span variants={itemVariants} className="text-56 leading-none">
                  {id}
                </motion.span>
                <motion.p variants={itemVariants} className="text-27 leading-6 whitespace-pre-line">
                  {t(`home.sustainability.items.${id}`)}
                </motion.p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      <motion.div
        className="h-full w-full bg-[#76E398] absolute mix-blend-soft-light z-50 top-0 left-0"
        initial="initial"
        whileInView="whileInView"
        exit="exit"
        variants={photoVariants}
      ></motion.div>

      <motion.img
        src="/images/home/green.jpg"
        className="h-full w-full absolute object-cover object-center top-0 left-0"
        initial="initial"
        whileInView="whileInView"
        exit="exit"
        variants={photoVariants}
      />
    </motion.div>
  );
};

export default Section2;
